export const LOGIN_API = "auth/login";
export const SECURITY_API = "v1/users/security";
